import React from "react";
import Eyebrow from "./Eyebrow";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  eyebrow: string;
  title: React.ReactNode;
  size?: "default" | "compact";
  children?: React.ReactNode;
  className?: string;
}

const PageHeader = ({ eyebrow, title, size = "default", children, className }: PageHeaderProps) => {
  return (
    <div className={cn("max-w-4xl", className)}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1
        className={cn(
          "mt-4 text-4xl leading-[1.1] font-bold tracking-tight text-balance text-navy",
          size === "compact" ? "sm:text-[2.75rem] lg:text-5xl" : "sm:text-5xl lg:text-[3.5rem]",
        )}
      >
        {title}
      </h1>
      {children && <div className="mt-5 max-w-3xl space-y-4 text-lg leading-relaxed text-slate-600">{children}</div>}
    </div>
  );
};

export default PageHeader;
